import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay, map, take } from 'rxjs';


import { auth_urls } from '../Constants/api-constants';
import { EncryptDecryptService } from '../EncrptyDecrypt/encrypt-decrypt.service';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  observe: 'response' as const
};

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly encryptDecryptService: EncryptDecryptService
  ) { }

  private getTokenForChangePasswordFromSession(): string {
    if (!globalThis.window?.sessionStorage) {
      return '';
    }
    const stored = sessionStorage.getItem('tokenForChangePassword');
    if (!stored) {
      return '';
    }
    // Backward compatible: if it's not encrypted, return as-is
    if (!stored.startsWith('enc:')) {
      return stored;
    }

    const decrypted = this.encryptDecryptService.decryptUsingAES256(stored.slice(4));
    return decrypted?.length ? decrypted : '';
  }

  Login(data:any): Observable<any> {
    return this.httpClient.post<any>(auth_urls.login, data, httpOptions).pipe(
      shareReplay(),
      map((response: any) => {
        return {
          success: response.status,
          data: response.body
        } as any;
      })
    );
  }

  /**
   * Mints a single-use handoff code so the admin app can sign this user in
   * without the raw JWT travelling in the URL.
   */
  getWebHandoffCode(): Observable<any> {
    return this.httpClient
      .post<any>(auth_urls.create_web_handoff_code, {}, httpOptions)
      .pipe(
        take(1),
        map((response: any) => {
          return {
            success: response?.status,
            data: response?.body
          } as any;
        })
      );
  }

  exchangeWebHandoffCode(code: string): Observable<any> {
    return this.httpClient
      .post<any>(auth_urls.exchange_web_handoff_code, { code }, httpOptions)
      .pipe(
        map((response: any) => {
          return {
            success: response?.status,
            data: response?.body
          } as any;
        })
      );
  }
  forgot_password(email: any,role_id:number=0,role_field_id:number=0) {
    let params = new HttpParams();

    if (email != '') {
      params = params.set('email', email);
    }
    if (role_id > 0) {
      params = params.set('role_id', role_id);
    }
    if (role_field_id > 0) {
      params = params.set('role_field_id', role_field_id);
    }
    return this.httpClient.get<any>(auth_urls.send_otp,  { params, ...httpOptions }).pipe(
      shareReplay(),
      map((response: any) => {
        return {
          code: response.status,
          msg: response.body.msg,
          data: response.body
        } as any;
      })
    );
  }
  verify_email_change(new_email: string, otp_code: string): Observable<any> {
    return this.httpClient.post<any>(auth_urls.verify_email_change, { new_email, otp_code }, httpOptions).pipe(
      map((response: any) => response.body)
    );
  }

  send_email_change_otp(email: string): Observable<any> {
    const params = new HttpParams().set('email', email).set('is_email_change', 'true');
    return this.httpClient.get<any>(auth_urls.send_otp, { params, ...httpOptions }).pipe(
      map((response: any) => response.body)
    );
  }

  verifyOTP(data: any): Observable<any> {
    const httpOptionsAuth ={
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

        'auth': 'Bearer ' + this.getTokenForChangePasswordFromSession()
      }) ,
      observe: 'response' as const
    };
    return this.httpClient.post<any>(auth_urls.verify_otp+'?is_signup=false', data, httpOptionsAuth).pipe(
      shareReplay(),
      map((response: any) => {
        return {
          code: response.status,
          msg: response.body.msg,
          data: response.body
        } as any;
      })
    );
  }
  changePassword(data: any): Observable<any> {
    const httpOptionsAuth ={
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": 'Bearer ' + this.getTokenForChangePasswordFromSession()
      }) ,
      observe: 'response' as const
    };

    return this.httpClient.post<any>(auth_urls.change_password, data, httpOptionsAuth).pipe(
      shareReplay(),
      map((response: any) => {
        return {
          code: response.status,
          msg: response.body.msg,
          data: response.body
        } as any;
      })
    );
  }
  password_reset(data: any): Observable<any> {
    const httpOptionsAuth ={
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "authorization": 'Bearer ' + this.getTokenForChangePasswordFromSession()
      }) ,
      observe: 'response' as const
    };

    return this.httpClient.post<any>(auth_urls.password_reset, data, httpOptionsAuth).pipe(
      shareReplay(),
      map((response: any) => {
        return {
          code: response.status,
          msg: response.body.msg,
          data: response.body
        } as any;
      })
    );
  }
  signUpVerification(email: any, role_id: number = 0, role_field_id: number = 0, password: any) {
    let params = new HttpParams();

    if (email != '') {
      params = params.set('email', email);
    }
    if (role_id > 0) {
      params = params.set('role_id', role_id);
    }
    if (role_field_id > 0) {
      params = params.set('role_field_id', role_field_id);
    }
     if (password !='') {
      params = params.set('password', password);
    }
    return this.httpClient.get<any>(auth_urls.signup_verification,  { params, ...httpOptions }).pipe(
      shareReplay(),
      map((response: any) => {
        return {
          code: response.status,
          msg: response.body.msg,
          data: response.body
        } as any;
      })
    );
  }
  verifysignupOtp(data: any): Observable<any> {
    const httpOptionsAuth ={
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

        'auth': 'Bearer ' + (typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined' ? sessionStorage.getItem('tokenForsignup') : '')
      }) ,
      observe: 'response' as const
    };
    return this.httpClient.post<any>(auth_urls.verify_otp+'?is_signup=true', data, httpOptionsAuth).pipe(
      shareReplay(),
      map((response: any) => {
        return {
          code: response.status,
          msg: response.body.msg,
          data: response.body
        } as any;
      })
    );
  }

}
